module.exports = __webpack_public_path__ + "static/img/zldh.54b576fb.png";